const formatDecimal = (value, rounding) => {
  const [whole, decimal] = value.toString().split('.');
  const formattedDecimal =
    decimal && decimal.length < rounding
      ? decimal.padEnd(rounding, '0')
      : decimal;
  return decimal ? `${whole}.${formattedDecimal}` : value.toString();
};
export default formatDecimal;
